import { useLayoutEffect, useRef } from 'react';

type MoneyTextProps = {
  value: string;
  className?: string;
  currencyClassName?: string;
  fit?: boolean;
  minimumScale?: number;
};

export function MoneyText({
  value,
  className,
  currencyClassName,
  fit = false,
  minimumScale = 0.72,
}: MoneyTextProps) {
  const elementRef = useRef<HTMLSpanElement>(null);
  useLayoutEffect(() => {
    const element = elementRef.current;
    if (!fit || !element) return;
    let active = true;
    const resize = () => {
      if (!active) return;
      element.style.fontSize = '';
      const fontSize = Number.parseFloat(getComputedStyle(element).fontSize);
      if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth) {
        element.style.fontSize = `${fontSize * Math.max(minimumScale, element.clientWidth / element.scrollWidth)}px`;
      }
    };
    resize();
    const observer = typeof ResizeObserver === 'undefined' ? undefined : new ResizeObserver(resize);
    observer?.observe(element);
    void document.fonts?.ready.then(resize);
    return () => { active = false; observer?.disconnect(); };
  }, [fit, minimumScale, value]);
  const match = value.match(/^(.*?)\s*₽$/u);
  const amount = match?.[1] ?? value;

  return (
    <span ref={elementRef} className={className} aria-label={value}>
      {amount}
      {match !== null && (
        <span className={currencyClassName}> ₽</span>
      )}
    </span>
  );
}
